export const downloadVcsFile = (vcsContent, fileName) => {
  const blob = new Blob([vcsContent], { type: 'text/calendar;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link); // Append link to the body
  link.click(); // Programmatically click the link to trigger the download
  document.body.removeChild(link); // Remove link from the body
};
